import './booking-management.css';
import { createRoot } from '@wordpress/element';
import { QueryClientProvider } from '@tanstack/react-query';
import { fieldQueryClientFactory } from '../fields/lib/queryClient';
import BookingManagement from './components/BookingManagement';
import { BookingStoreProvider } from '../fields/contexts/BookingStoreContext';
import { createBookingStore } from '../fields/store/createBookingStore';

const container = document.getElementById('gpb-booking-management');
const queryClient = fieldQueryClientFactory();
const store = createBookingStore('booking-management');

if (container) {
	const root = createRoot(container);
	root.render(
		<QueryClientProvider client={queryClient}>
			<BookingStoreProvider store={store}>
				<BookingManagement />
			</BookingStoreProvider>
		</QueryClientProvider>
	);
} else {
	// eslint-disable-next-line no-console
	console.error('GP Bookings: Container #gpb-booking-management not found.');
}
